/**
 * Main App Component
 *
 * Sets up routing, authentication, and global providers for
 * the Victorian Sliders admin application.
 */


import { NotificationProvider } from '@/contexts/NotificationContext'
import { ProductConfigProvider } from '@/contexts/ProductConfigContext'
import { AppRoutes } from '@/routes'
import { AppProvider } from './provider/app'

function App() {
  return (
    <AppProvider>
        <NotificationProvider>
          <ProductConfigProvider>
            <AppRoutes />
          </ProductConfigProvider>
      </NotificationProvider>
    </AppProvider>

  )
}

export default App
